// Exporta a área recortada (em pixels da imagem original) como File.
// Mantém jpeg/png/webp; qualquer outro formato (gif, heic, bmp...) sai como jpeg.
const KEEP_TYPES = ['image/jpeg', 'image/png', 'image/webp'];
const MAX_SIDE = 4096;

const loadImage = (src) => new Promise((resolve, reject) => {
  const img = new Image();
  img.onload = () => resolve(img);
  img.onerror = () => reject(new Error('Não foi possível carregar a imagem.'));
  img.src = src;
});

export async function cropImageFile(file, area, imageSrc) {
  const img = await loadImage(imageSrc);
  const type = KEEP_TYPES.includes(file.type) ? file.type : 'image/jpeg';
  const scale = Math.min(1, MAX_SIDE / Math.max(area.width, area.height));
  const canvas = document.createElement('canvas');
  canvas.width = Math.max(1, Math.round(area.width * scale));
  canvas.height = Math.max(1, Math.round(area.height * scale));
  const ctx = canvas.getContext('2d');
  if (type === 'image/jpeg') { ctx.fillStyle = '#FFFFFF'; ctx.fillRect(0, 0, canvas.width, canvas.height); }
  ctx.drawImage(img, area.x, area.y, area.width, area.height, 0, 0, canvas.width, canvas.height);
  const blob = await new Promise((resolve) => canvas.toBlob(resolve, type, 0.92));
  if (!blob) throw new Error('Não foi possível recortar a imagem.');
  const ext = type === 'image/png' ? 'png' : type === 'image/webp' ? 'webp' : 'jpg';
  const base = file.name.replace(/\.[^.]+$/, '') || 'imagem';
  return new File([blob], `${base}.${ext}`, { type, lastModified: Date.now() });
}
